import { render, staticRenderFns } from "./SNotify.vue?vue&type=template&id=aa8f5154&scoped=true&"
import script from "./SNotify.vue?vue&type=script&lang=js&"
export * from "./SNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8f5154",
  null
  
)

export default component.exports